import React from 'react'

function SvgFacebook(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M17.79 1v3.55h-2.11a1.94 1.94 0 00-1.55.45 2.19 2.19 0 00-.4 1.44V9h3.92l-.52 4h-3.4v10.14h-4.1V13H6.21V9h3.42V6.09A5.17 5.17 0 0111 2.23 5 5 0 0114.73.86a21.92 21.92 0 013.06.14z" />
    </svg>
  )
}

export default SvgFacebook
